
import React, { useEffect, useRef, useState } from "react";
import Calendar from "./child/Calendar";
import { Icon } from "@iconify/react/dist/iconify.js";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { Container, Button, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

const BaseUrl = process.env.REACT_APP_API;


const DatePicker = ({ id, placeholder }) => {
  const datePickerRef = useRef(null);

  useEffect(() => {
    flatpickr(datePickerRef.current, {
      enableTime: true,
      dateFormat: "d/m/Y H:i",
    });
  }, []);

  return (
    <input
      ref={datePickerRef}
      id={id}
      type="text"
      className="form-control radius-8 bg-base"
      placeholder={placeholder}
    />
  );
};

const getCompanyIdFromToken = () => {
  const token = sessionStorage.getItem("IndToken");
  if (!token) {
    return null;
  }

  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const decodedData = JSON.parse(atob(base64));
    return decodedData.company_id || null;
  } catch (error) {
    console.error("Error decoding JWT:", error);
    return null;
  }
};

const CalendarMainLayer = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        setLoading(true);
        const companyId = getCompanyIdFromToken();
        if (!companyId) {
          setLoading(false);
          return;
        }

        const response = await axios.post(`${BaseUrl}/getDocuments`, {
          user_id: companyId,
        });
        setDocuments(response.data);
      } catch (error) {
        console.error("Error fetching documents:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, []);

  const handleDownloadStakeholder = async (filename) => {
    try {
      const companyId = getCompanyIdFromToken();
      if (!companyId) return;

      const response = await fetch(
        `${BaseUrl}/download/documents/${filename}?person_id=${companyId}`
      );

      if (!response.ok) {
        toast.error("Failed to download the file.");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("File downloaded successfully.");
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error("Error downloading file.");
    }
  };

  return (
    <Container className="mt-5">
      <Form>
        <fieldset style={{ padding: "20px", display: "block" }}>
          <div
            style={{
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0px 0px 20px #748292",
              transition: "all 0.5s ease-in-out",
            }}
          >
            <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
              Documents
            </h6>
            {loading ? (
              <div className="d-flex justify-content-center">
                <Spinner animation="border" size="sm" />
              </div>
            ) : documents.length === 0 ? (
              <p>No Documents Available</p>
            ) : (
              <ul>
                {documents.map((doc) => (
                  <li key={doc.id}>
                    {doc.filename} -
                    <Button
                      variant="link"
                      onClick={() => handleDownloadStakeholder(doc.filename)}
                    >
                      Download
                    </Button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </fieldset>
      </Form>
    </Container>
  );
};

export default CalendarMainLayer;
